import { render, staticRenderFns } from "./TicketWithComments.vue?vue&type=template&id=6588ad98"
import script from "./TicketWithComments.vue?vue&type=script&lang=js"
export * from "./TicketWithComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports